define('angular-diretivas-site',[], function() {
    /* global _ */
    var app = angular.module('angular-diretivas-site', []);

    
       

    app.directive('pressEnter', function () { //diretiva espqcifica para este formulário
        return function (scope, element, attrs) {
            element.bind("keypress", function (event) {
                if (event.which == 13) {
                    scope.$apply(function(){
                        scope.$eval(attrs.pressEnter);
                        event.preventDefault();
                    })

                }
            });
        };
    });





});
